export default function Problem() {
  const lines = [
    "You earn",
    "You plan",
    "But when it's time to spend...",
    "money isn't ready",
    "So you wait",
    "or swipe credit",
    "or feel money tight",
  ];

  return (
    <section className="bg-[#f7f4ff] px-4 py-20 sm:px-6 lg:px-8 lg:py-32">
      <div className="mx-auto max-w-7xl">
        <div className="space-y-3 text-center">
          {lines.map((line, index) => (
            <div
              key={line}
              className={`text-3xl font-black font-montserrat tracking-[-0.03em] sm:text-5xl lg:text-6xl ${index === 0 || index === 1 || index === 4
                ? "text-[#0d0828]"
                : "font-medium text-[#0d082899]"
                }`}
            >
              {line}
            </div>
          ))}
        </div>

        <div className="mx-auto mt-16 max-w-4xl rounded-[32px] border border-purple-100 bg-white p-8 text-center shadow-[0_25px_80px_rgba(124,58,237,0.12)] sm:p-12 lg:p-16">
          <div className="mx-auto mb-8 h-1.5 w-24 rounded-full bg-[#4C42FD]" />
          <h2 className="text-3xl font-montserrat font-black leading-tight tracking-[-0.04em] text-[#0d0828] sm:text-5xl">
            It&apos;s not an income problem.
            <br />
            It&apos;s a{" "}
            <span className="bg-gradient-to-r font-montserrat text-[#4C42FD] bg-clip-text">
              timing
            </span>{" "}
            problem.
          </h2>
          <div className="mt-8 text-2xl font-montserrat font-black text-[#0d0828] sm:text-4xl">
            PoolMoney fixes this
          </div>
          <p className="mt-4 text-lg font-montserrat leading-8 text-[#0d0828b3]">
            Your money gets sorted{" "}
            <span className="font-bold text-[#0d0828]">automatically</span> before
            you spend.
          </p>
        </div>
      </div>
    </section>
  );
}
